import { Component, OnInit } from '@angular/core';
import { CorporationService } from './modules/corporation/services/corporation.service';

@Component({
  selector: 'pbk-root',
  templateUrl: './app.component.html',
})
export class AppComponent {}
